import { useEffect, useRef, useState } from "react";
import { MapPin, X } from "lucide-react";
import * as XLSX from "xlsx";
import { useStateValue } from "../../context/StateProvider";
import { deleteApp, initializeApp } from "firebase/app";
import { firebaseConfig, firestored } from "../../firebase/firebaseConfig";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import DealCard from "./deal-card";

const StatDetails = ({
  onClose,
  onSubmit,
  Data,
  selectedstat,
  isStatCard,
  statUserId,
  role,
}) => {
  const [{ user, employees, teamleads }, dispatch] = useStateValue();

  const [loading, setloading] = useState(false);

  function dealinfo(title, description) {
    return (
      <div className="flex flex-col items-center">
        <span className="text-xs text-gray-500 mb-1">{title}</span>
        <span className="font-normal text-slate-900">{description}</span>
      </div>
    );
  }

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center ">
        <div className=" rounded-lg  overflow-hidden shadow-2xl w-[90%] lg:w-[70%] h-[85%]  bg-white relative">
          {loading && (
            <div className="position absolute h-full w-full bg-black/50 flex justify-center items-center">
              <div role="status" className="">
                <svg
                  aria-hidden="true"
                  class="size-10 text-gray-200 animate-spin dark:text-white fill-[#1E293B]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-black/10 h-[12%] bg-[#1E293B] text-white ">
            <div>
              <h2 className="text-xl font-semibold">{selectedstat}</h2>
            </div>
            <button
              onClick={onClose}
              className="w-9 h-9 bg-white/20 hover:bg-white/30 rounded-full text-lg flex items-center justify-center transition-all hover:rotate-90"
            >
              <X className="w-6 h-6 text-foreground" />
            </button>
          </div>
          {/* {Data.length > 0 && (
            <div className="flex items-center justify-between py-2 px-[14px]">
              <div>
                <h2 className="text-lg font-semibold text-linkColor">
                  {"Users Found - " + Data.length}
                </h2>
              </div>
            </div>
          )} */}
          <div className="w-full  h-[88%]  overflow-y-auto form-scrollbar py-2 ">
            {Data.length > 0 ? (
              <div className="grid gap-6">
                {Data.map((item, i) => {
                  return (
                    <div className="w-full px-[10px]">
                      {
                        <DealCard
                          data={item}
                          viewdetails={true}
                          highlight={true}
                          selectedstat={selectedstat}
                          isStatCard={isStatCard}
                          statUserId={statUserId}
                          role={role}
                          // isShowEdit={true}
                          // onEdit={(dealData) => handleOnEdit(dealData)}
                          // onAprove={(dealData) => handleOnApprove(dealData)}
                        />
                      }
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="w-full px-[20px] py-[20px]">
                <h2 className="text-xl font-semibold">No Record Found</h2>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default StatDetails;
